<template>
  <div class="d-flex justify-center">
    <v-menu offset-y bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn :disabled="isActionYet" v-bind="attrs" v-on="on" icon>
          <v-icon color="#0D47A1">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-if="canDelete">
          <v-icon>mdi-trash</v-icon>
          <v-list-item-title style="cursor: pointer; color: red" @click="onRemove()"> Xóa giáo viên</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    isActionYet: Boolean,
    id: String
  },
  computed: {
    canDelete() {
      return true
    }
  },
  methods: {
    ...mapActions('salaryGroupTeacher', ['delete']),
    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa nhận xóa giáo viên?',
        text:
          'Giáo viên sẽ bị xoá khỏi danh sách giáo viên này.<br/> Thao tác này sẽ không thể hoàn tác. Bạn có chắc chắn muốn xoá giáo viên?',
        okText: 'Xóa',
        cancelText: 'Không',
        type: 'delete',
        done: async () => {
          this.delete({ id: this.id, groupId: this.$route.params.id })
        }
      })
    }
  }
}
</script>
